import { gql } from '@apollo/client';

export const GET_TOKEN_IDS_FOR_OWNERS = gql`
  query GetTokenIdsForOwners($data: GetTokenIdsForOwnersInput!) {
    getTokenIdsForOwners(data: $data) {
      tokens {
        contractAddress
        tokenIds
      }
      ownerAddresses
    }
  }
`;
